type SentryErrorEvent = {
  exception?: {
    values?: Array<{
      value?: string;
    }>;
  };
};

const CLERK_SESSION_TOUCH_PREFIX = "ClerkJS: Network error at \"https://clerk.teamz-tennis.com/v1/client/sessions/";
const TRANSIENT_FETCH_ERRORS = [
  "TypeError: Failed to fetch",
  "TypeError: Load failed",
];

export function shouldDropSentryEvent(event: SentryErrorEvent) {
  return event.exception?.values?.some(({ value }) => (
    typeof value === "string"
    && value.includes(CLERK_SESSION_TOUCH_PREFIX)
    && value.includes("/touch?")
    && TRANSIENT_FETCH_ERRORS.some(fetchError => value.includes(fetchError))
  )) ?? false;
}
